import ElementContent from '@/components/sections/builder/elements/body/product-carousel/content';
import ElementSetting from '@/components/sections/builder/elements/body/product-carousel/setting';
import { ProductCarouselElementDataType } from '@/components/sections/builder/elements/body/product-carousel/type';
import { BetweenHorizontalStart } from 'lucide-react';

const defaultData: ProductCarouselElementDataType = {
  name: 'Product Carousel',
  contentAlign: 'left',
  headingLabel: 'Featured products',
  headingSize: 'small',
  textLabel: '',
  textStyle: 'body',
  limit: 4,
  totalCol: 4,
  totalColMobile: 2,
  size: 'small',
  showImage: true,
  showCategory: true,
  showShadow: false,
  rounded: 0,
  imageRatio: 'square',
  viewAllStyle: 'default',
  labelViewAll: 'View all',
  positionViewAll: 'bottom',
  enableCarousel: true,
  enableQuickAddButton: false,
  autoplay: false,
  changeSlidesEvery: 5,
};

export const ElementPreviewIcon = BetweenHorizontalStart;

const ProductCarousel = {
  type: 'product_carousel',
  group: 'body',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
};

export default ProductCarousel;
